/** F.5.2/F.5.3/F.5.4 — Admin Financeiro use case impls (listagens cross-venda + cobranca envios). */
import type { AdminParcelaGateway, ListAdminParcelasParams } from '@/application/port/out/AdminParcelaGateway';
import type { AdminPagamentoGateway, ListAdminPagamentosParams } from '@/application/port/out/AdminPagamentoGateway';
import type { CobrancaEnvioGateway } from '@/application/port/out/CobrancaEnvioGateway';
import type { VendaParcela } from '@/domain/model/Venda';
import type { VendaPagamento } from '@/domain/model/VendaPagamento';
import type { CobrancaEnvio } from '@/domain/model/CobrancaEnvio';
import type { Page } from '@/domain/model/Page';
import type { ListAdminParcelasUseCase } from '@/application/port/in/AdminParcelaUseCase';
import type { ListAdminPagamentosUseCase } from '@/application/port/in/AdminPagamentoUseCase';
import type {
  ListCobrancaEnviosUseCase, ListCobrancaEnviosByParcelaUseCase,
} from '@/application/port/in/CobrancaEnvioUseCase';

export class ListAdminParcelas implements ListAdminParcelasUseCase {
  constructor(private readonly gateway: AdminParcelaGateway) {}
  execute(params: ListAdminParcelasParams): Promise<Page<VendaParcela>> {
    return this.gateway.list(params);
  }
}

export class ListAdminPagamentos implements ListAdminPagamentosUseCase {
  constructor(private readonly gateway: AdminPagamentoGateway) {}
  execute(params: ListAdminPagamentosParams): Promise<Page<VendaPagamento>> {
    return this.gateway.list(params);
  }
}

export class ListCobrancaEnvios implements ListCobrancaEnviosUseCase {
  constructor(private readonly gateway: CobrancaEnvioGateway) {}
  execute(limit?: number): Promise<CobrancaEnvio[]> {
    return this.gateway.listRecentes(limit);
  }
}

export class ListCobrancaEnviosByParcela implements ListCobrancaEnviosByParcelaUseCase {
  constructor(private readonly gateway: CobrancaEnvioGateway) {}
  execute(parcelaId: string): Promise<CobrancaEnvio[]> {
    return this.gateway.listByParcela(parcelaId);
  }
}
